var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('users-table')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('investments-table')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }